import { Link } from 'react-router-dom';
import {motion} from 'motion/react';
import CDMorph from './landingAnimation.js'

/*
This will show 'MP3JUUG' in bolded letters
in the middle of the screen with a picture
of a CD morphing into an NFC card originally
with more mediums to be added to the animation
*/

function Landing(){
    return (
        <div className='landing-header'>
            <motion.h1>From CD to music card...</motion.h1>
            <CDMorph/>
        <Link to='/land'>
            <button>Try now</button>
        </Link>
        <Link to='/link'>
            <button>Download</button>
        </Link>
        </div>
    );

}

export default Landing;